import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  postMessage: null,
  postError: null,
  data: undefined,
};

const postPetFormOneSlice = createSlice({
  name: "postPetFormOne",
  initialState,
  reducers: {
    postPetFormOneStart(state, payload) {
      state.loading = true;
      state.postError = null;
      state.postMessage = null;
    },

    postPetFormOneSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    postPetFormOneDataSuccess(state, action) {
      state.loading = false;
    },

    postPetFormOneFailure(state, action) {
      state.loading = false;
      state.postError = action.payload;
      state.postMessage = null;
    },

    clearMessage: (state) => {
      state.postError = null;
      state.postMessage = null;
    },
  },
});

export const {
  postPetFormOneStart,
  postPetFormOneSuccess,
  postPetFormOneFailure,
  postPetFormOneDataSuccess,
  clearError,
  clearMessage,
} = postPetFormOneSlice.actions;

export default postPetFormOneSlice.reducer;
